import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

import { selectionConstants, ROUTES } from "../../../../constants";
import { assetsConstants } from "../../../../constants/assets.constants";
import SideImage from "../../../../shared/components/SideImage/SideImage";
import SelectionField from "../../../../shared/components/Fields/SelectionField";

const AccountSelection = (props) => {
  const { t } = useTranslation("common");
  const history = useHistory();

  const [selectionAccount, setSelection] = useState(
    selectionConstants.CUSTOMER
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (props?.authentication?.isAuthenticated) {
      window.location.replace(
        `${process.env.REACT_APP_HOST_BASE_URL}${ROUTES.CUSTOMER_DASHBOARD}`
      );
    } else if (props.isShutterbAuthenticated) {
      window.location.replace(
        `${process.env.REACT_APP_HOST_BASE_URL}${ROUTES.SHUUTERB_DASHBOARD}`
      );
    }
    // eslint-disable-next-line
  }, [props.authentication.isAuthenticated, props.isShutterbAuthenticated]);

  return (
    <SideImage
      imageUrl={assetsConstants.ACCOUNT_SELECTION_IMAGE_URL}
      shouldShowCenter={true}
    >
      <div className="pb-3">
        <h4 className="selection-heading font-weight-bold py-4 mb-0">
          {t("account_selection_heading")}
        </h4>
        <div className="div">
          <SelectionField
            text={t("client")}
            selectedAccountType={selectionAccount}
            selectionType={selectionConstants.CUSTOMER}
            setSelectedAccountType={setSelection}
          />
          <SelectionField
            text={t("shutterb")}
            selectedAccountType={selectionAccount}
            selectionType={selectionConstants.SHUTTERB}
            setSelectedAccountType={setSelection}
          />
          <div>
            <button
              className="button-common button-fill btn-selection w-100 mt-2"
              onClick={() => {
                history.push(`${ROUTES.LOGIN}/${selectionAccount.toLowerCase()}`, {
                  shouldShowBackButton: true,
                });
              }}
            >
              {t("continue")}
            </button>
          </div>
        </div>
      </div>
    </SideImage>
  );
};

const mapStateToProps = (state) => ({
  authentication: state.authentication,
  spinnerActions: state.system.spinnerActions,
  isShutterbAuthenticated: state.shutterbAuthentication.isShutterbAuthenticated,
});

// mapping action and store the function via props
export default connect(mapStateToProps, null)(withRouter(AccountSelection));
